import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const FindWordsStepTwoCollections = ({
  getCollections,
  hasLoaded,
  findWordsStepTwoCollections,
  findWordsStepTwoCurrency,
  pageCount,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="find-words-collections-container--step-two"
      collectionsPath={paths.FIND_WORDS_STEP_TWO}
      currency={findWordsStepTwoCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={findWordsStepTwoCollections}
      levelsPath={paths.FIND_WORDS_STEP_TWO_LEVELS}
      pageCount={pageCount}
      student={student}
      title={messages.game.findWords}
    />
  );
};

FindWordsStepTwoCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  findWordsStepTwoCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  findWordsStepTwoCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.findWordsStepTwoCollections.getHasLoaded(state),
  findWordsStepTwoCurrency: selectors.findWordsStepTwoCollections.getCurrencyData(
    state
  ),
  findWordsStepTwoCollections: selectors.findWordsStepTwoCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.findWordsStepTwoCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.findWordsStepTwo,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FindWordsStepTwoCollections);
